import { createAction } from 'redux-actions';
import apiServiceInstance from '../../services';
import GlobalTypes from '../types/GlobalType';
import { showError } from './GlobalToastActions';

export const successRequest = createAction(GlobalTypes.actions.successRequest);
export const startRequest = createAction(GlobalTypes.actions.startRequest);

/**
 * @param {object} error
 * @param {boolean} showToast defaults to false
 */
export const failedRequest =
  (error, showToast = false) =>
  (dispatch) => {
    const { response = {} } = error;
    const msgError = (response.data && response.data.description) || 'labelNetworkError';

    //TODO: Remove when the poc is done
    window.newrelic.addPageAction('failedRequestError', { error: msgError });

    if (error.response && error.response.status && !apiServiceInstance.logoutStatus.includes(error.response.status)) {
      if (showToast) {
        dispatch(showError(msgError));
      }
    }
    return dispatch({ type: GlobalTypes.actions.failedRequest, payload: error });
  };
